import { isContainerLane } from '@/lib/lanes';

/** What the guest launches a sample AS, beside the name it arrived under.
 *
 *  Worth showing because the two disagree exactly where it matters. A sample
 *  named after its digest carries no extension at all, and one whose content
 *  overrode a misleading name is launched as something the filename never
 *  said - a workbook that arrives as `.bin` runs as `.xlsx`. Without this the
 *  row describes a run that did not happen.
 *
 *  Absent when nothing claims the sample: no tag rather than a guess.
 *
 *  `lane` is required rather than optional because the field it renders is
 *  not lane-safe. `detonation_kind` is resolved from the submission's stored
 *  file type and, failing that, from its target NAME - and a URL submission's
 *  target name is the URL, so `https://x/invoice.pdf` resolves to PDF and the
 *  row claims a detonation that never happened. `/v1` publishes the field only
 *  for a file target for exactly this reason, and the guard belongs here rather
 *  than at each call site so a new one cannot forget it. */
export function DetonationTag({ kind, lane }: { kind?: string; lane: string }) {
  if (!kind || isContainerLane(lane)) return null;
  return (
    <span
      className="shrink-0 rounded border border-rule-strong px-1.5 py-0.5 text-mini font-medium text-ink-300"
      title={`Detonated as ${kind}`}
    >
      {kind}
    </span>
  );
}
